import clsx from "clsx";
import React, { Fragment, FunctionComponent } from "react";
import { Link } from "wouter";

import { useIsNationalSite } from "../../stores/hooks/useIsNationalSite";
import { useHeaderLinks } from "./useHeaderLinks";
import { useLanguageSelect } from "./useLanguageSelect";

export const Nav: FunctionComponent = () => {
  const { oppositeLanguage, oppositeLanguageLink } = useLanguageSelect();
  const links = useHeaderLinks();
  const isNational = useIsNationalSite();

  return (
    <nav className={clsx("tw-header__nav", !isNational && "mb-2")}>
      {links.map(({ href, name, to }) => {
        const linkElement = href ? (
          <a href={href}>{name}</a>
        ) : (
          <Link to={to!}>
            <a>{name}</a>
          </Link>
        );
        return (
          <Fragment key={name}>
            {linkElement}
            <span className="opacity-60">|</span>
          </Fragment>
        );
      })}
      <Link to={oppositeLanguageLink}>
        <a>{oppositeLanguage.toUpperCase()}</a>
      </Link>
    </nav>
  );
};
